import classNames from 'classnames'
import React from 'react'

import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getProfilePath } from 'common'
import Store from 'store'
import { OverlayContext } from 'ui/utils/OverlayManager'

export function copyText(text: string) {
  const node = document.createElement('input')
  document.body.appendChild(node)
  node.value = text
  node.select()
  document.execCommand('copy')
  document.body.removeChild(node)
}

export function CopyNotify({ pos, onClose = () => {} }: { pos: React.CSSProperties; onClose?: () => void }) {
  const [animating, setAnimating] = React.useState(false)
  React.useEffect(() => {
    setTimeout(() => setAnimating(true), 1)
  }, [])
  React.useEffect(() => {
    setTimeout(onClose, 1000)
  }, [onClose])

  return (
    <div className={classNames('poe-notify', { 'poe-animating': animating })} style={pos}>
      <FontAwesomeIcon icon={faCopy} />
    </div>
  )
}

export function useProfileSetId() {
  const storeid = Store.useSelector(
    (store) => store.imported && store.imported.modified !== 'heavy' && store.imported.id
  )
  const active = Store.useSelector((store) => (store.embeds.length > 1 ? store.activeEmbed + 1 : null))
  if (storeid) return { id: storeid, set: active }
}

export function CopyBox({ text, ...props }: { text: string } & React.HTMLAttributes<HTMLDivElement>) {
  const overlays = React.useContext(OverlayContext)
  const onClick = React.useCallback(
    (event: React.MouseEvent) => {
      copyText(text)
      overlays.async(<CopyNotify pos={{ left: event.pageX, top: event.pageY }} />)
    },
    [text, overlays]
  )

  return (
    <div className="poe-CopyBox" onClick={onClick} {...props}>
      {text}
    </div>
  )
}

export function CopyEmbedBox({ type, height }: { type: string; height?: number }) {
  const storeid = Store.useSelector((store) =>
    store.imported && store.imported.modified !== 'heavy' ? store.imported.id : undefined
  )
  const active = Store.useSelector((store) => store.embeds[store.activeEmbed]?.id)
  if (!storeid) {
    return <div className="poe-CopyBox poe-disabled">Save profile to get embed links.</div>
  }

  const url = new URL(getProfilePath(storeid), window.location.href)
  let hash = '#' + encodeURIComponent(active || '') + '&' + type
  if (height) hash += `&height=${height}`
  url.hash = hash

  return <CopyBox text={url.href} />
}

export function CopyEmbedAsTooltipBox({ type }: { type: string; height?: number }) {
  const storeid = Store.useSelector((store) =>
    store.imported && store.imported.modified !== 'heavy' ? store.imported.id : undefined
  )
  const active = Store.useSelector((store) => store.embeds[store.activeEmbed]?.id)
  if (!storeid) {
    return <div className="poe-CopyBox poe-disabled">Save profile to get embed links.</div>
  }

  const result = `[poe-${type} id=${active} profile=${storeid}][/poe-${type}]`

  return <CopyBox text={result} />
}
